/**
 * Docebo Location model
 */
export class Location {
  constructor(
    public accomodations: string,
    public address: string,
    public email: string,
    public idCountry: string,
    public idLocation: number,
    public idZone: string,
    public isoCodeCountry: string,
    public name: string,
    public nameCountry: string,
    public otherInfo: string,
    public reachingInfo: string,
    public telephone: string
  ) {}
}
